import React from 'react';
import ReactDOM from 'react-dom/client';
import MerchantChatbot from './MerchantChatbox.jsx';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <MerchantChatbot />
    </React.StrictMode>
  );
}

